import { Component, OnInit, Input } from "@angular/core";
import { ByDayOfWeek, FirebaseService } from "src/app/core";

@Component({
  selector: "ll-summary-by-dow",
  templateUrl: "./summary-by-dow.component.html",
  styleUrls: ["./summary-by-dow.component.scss"]
})
export class SummaryByDowComponent implements OnInit {
  @Input() data: ByDayOfWeek[];
  @Input() venue: boolean;

  constructor(private fb: FirebaseService) {}
  ngOnInit() {
  }

  get tDays(): number {
    return this.data.reduce((acc, next) => acc + next.number_of_days, 0);
  }
  get tUnits(): number {
    return this.data.reduce((acc, next) => acc + next.units, 0);
  }
  get tAvgPrice(): number {
    return (
      this.data.reduce((acc, next) => acc + next.avg_price * next.units, 0) /
      this.tUnits
    );
  }

  get tSubtotal() {
    return this.data.reduce((acc, next) => acc + next.subtotal, 0);
  }

  get tServiceFees() {
    return this.data.reduce((acc, next) => acc + next.service_fees, 0);
  }
  get tTips() {
    return this.data.reduce((acc, next) => acc + next.tips, 0);
  }
  get tTipPercentage() {
    return this.data.reduce((acc, next) => acc + next.tip_percentage, 0);
  }
  get tTotal() {
    return this.data.reduce((acc, next) => acc + next.total, 0);
  }
  get tRedeemed() {
    return this.data.reduce((acc, next) => acc + next.redeemed, 0);
  }
  get tRedeemedPercentage() {
    // if (this.venue) return this.tRedeemed / this.fb.venue.orders.orders.length;
    return this.tRedeemed / this.fb.orders.orders.length;
  }
  get tRevenue() {
    return (
      this.data.reduce((acc, next) => acc + next.revenue_percentage, 0) /
      this.data.length
    );
  }
}
